/*
  Producttabs-layout – Deurbeslag Expert
  Deelt de eerste tab (Beschrijving) automatisch in:
    - kerncijfers-tegels bovenaan (uit de specificatietabel)
    - links de tekst, rechts een meescrollende specificatiekaart
  Bron van de specificaties:
    1. de eerste tabel in de productbeschrijving, anders
    2. de tabel uit de tab met metafield-specificaties (.product-specs-table)
  Zonder tabel blijft de tab ongewijzigd.
  Kleur en materiaal komen altijd letterlijk uit de metafields
  (data-kleur / data-materiaal op de config), nooit uit de tabel.
  Instellingen komen uit <div class="de-pt-config" data-phone data-reviews
  data-kleur data-materiaal>.
  Stijl staat in assets/component-tabs.css (laag "de-producttabs").
*/
(function () {
  'use strict';

  var SVG_OPEN = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">';
  var ICONS = {
    ruler: '<rect x="3" y="8" width="18" height="8" rx="1.5"/><path d="M7 8v3M11 8v4M15 8v3"/>',
    cube: '<path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z"/><path d="M12 12l8-4.5M12 12v9M12 12L4 7.5"/>',
    finish: '<path d="M12 3a9 9 0 1 0 0 18c1.1 0 1.6-.8 1.3-1.8-.3-1 .4-2.2 1.6-2.2H17a4 4 0 0 0 4-4c0-5.5-4-10-9-10z"/><circle cx="7.5" cy="11" r="1"/><circle cx="12" cy="7.5" r="1"/><circle cx="16.5" cy="11" r="1"/>',
    weight: '<path d="M6 8h12l2 12H4z"/><circle cx="12" cy="5" r="2.5"/>',
    door: '<path d="M6 21V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v17M4 21h16"/><circle cx="14.5" cy="12" r=".9"/>',
    tag: '<path d="M3 12V4a1 1 0 0 1 1-1h8l9 9-9 9z"/><circle cx="7.5" cy="7.5" r="1.2"/>',
    check: '<circle cx="12" cy="12" r="9"/><path d="M8 12.3l2.7 2.7L16 9.6"/>',
    list: '<path d="M9 6h11M9 12h11M9 18h11"/><circle cx="4.5" cy="6" r="1"/><circle cx="4.5" cy="12" r="1"/><circle cx="4.5" cy="18" r="1"/>',
    phone: '<path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2"/>'
  };

  /* Tegels uit de tabel, na Materiaal en Kleur (die uit metafields komen).
     Volgorde = prioriteit; eerste match per regel wint. */
  var TILE_RULES = [
    { re: /^(afmeting|maat|lengte|breedte|hoogte)/i, icon: 'ruler' },
    { re: /draag/i, icon: 'weight' },
    { re: /(geschikt|toepassing|type deur)/i, icon: 'door' },
    { re: /(bevestiging|montage)/i, icon: 'check' },
    { re: /^(type|vorm)/i, icon: 'tag' }
  ];
  /* Nooit als tegel uit de tabel: id-velden, en kleur/finish/materiaal
     (die tonen we alleen vanuit de metafields). */
  var EXCLUDE = /^(merk|ean|sku|barcode|artikelnummer|kleur|finish|afwerking|coating|materiaal)$/i;
  var MAX_TILES = 4;

  function icon(name) { return SVG_OPEN + (ICONS[name] || ICONS.check) + '</svg>'; }

  function el(tag, cls) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    return node;
  }

  function clean(text) { return (text || '').replace(/\s+/g, ' ').trim(); }

  function readRows(table) {
    var rows = [];
    for (var i = 0; i < table.rows.length; i++) {
      var cells = table.rows[i].cells;
      if (cells.length < 2) continue;
      var label = clean(cells[0].textContent);
      var value = clean(cells[1].textContent);
      if (label && value) rows.push({ label: label, value: value });
    }
    return rows;
  }

  function buildTiles(rows, config) {
    var picked = [];
    var used = {};
    var materiaal = clean(config && config.getAttribute('data-materiaal'));
    var kleur = clean(config && config.getAttribute('data-kleur'));

    /* Afmetingen eerst (uit de tabel) */
    var first = TILE_RULES[0];
    for (var a = 0; a < rows.length; a++) {
      if (!EXCLUDE.test(rows[a].label) && rows[a].value.length <= 40 && first.re.test(rows[a].label)) {
        used[a] = true;
        picked.push({ row: rows[a], icon: first.icon });
        break;
      }
    }
    if (materiaal) picked.push({ row: { label: 'Materiaal', value: materiaal }, icon: 'cube' });
    if (kleur) picked.push({ row: { label: 'Kleur', value: kleur }, icon: 'finish' });

    for (var r = 1; r < TILE_RULES.length && picked.length < MAX_TILES; r++) {
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        if (used[i] || EXCLUDE.test(row.label) || row.value.length > 40) continue;
        if (TILE_RULES[r].re.test(row.label)) {
          used[i] = true;
          picked.push({ row: row, icon: TILE_RULES[r].icon });
          break;
        }
      }
    }
    if (picked.length < 2) return null;

    var wrap = el('div', 'de-pt__tiles');
    picked.forEach(function (item) {
      var tile = el('div', 'de-pt__tile');
      var ic = el('span', 'de-pt__tile-icon');
      ic.innerHTML = icon(item.icon);
      var text = el('span', 'de-pt__tile-text');
      var label = el('span', 'de-pt__tile-label');
      label.textContent = item.row.label;
      var value = el('span', 'de-pt__tile-value');
      value.textContent = item.row.value;
      text.appendChild(label);
      text.appendChild(value);
      tile.appendChild(ic);
      tile.appendChild(text);
      wrap.appendChild(tile);
    });
    return wrap;
  }

  function addReviewCount(section, config) {
    var count = parseInt(config && config.getAttribute('data-reviews'), 10);
    if (!count || count < 1) return;
    var widget = section.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
    var panel = widget && widget.closest('.tabs__content');
    if (!panel) return;
    var button = section.querySelector('[role="tab"][aria-controls="' + panel.id + '"]');
    var name = button && button.querySelector('.tabs__tab-name');
    if (!name || name.querySelector('.de-pt-count')) return;
    var badge = el('span', 'de-pt-count');
    badge.textContent = count;
    name.appendChild(badge);
  }

  function layoutFirstTab(section, config) {
    var panel = section.querySelector('.tabs__content');
    var content = panel && panel.querySelector('.page__content');
    if (!content || content.querySelector('.de-pt')) return;

    var table = null;
    var heading = null;
    for (var c = 0; c < content.children.length; c++) {
      if (content.children[c].tagName === 'TABLE') { table = content.children[c]; break; }
    }
    if (table) {
      var prev = table.previousElementSibling;
      if (prev && /^H[2-5]$/.test(prev.tagName)) heading = prev;
    } else {
      var extra = section.querySelector('.product-specs-table table');
      if (extra && extra.rows.length > 1) table = extra.cloneNode(true);
    }
    if (!table) return;

    var rows = readRows(table);
    if (rows.length < 2) return;

    var root = el('div', 'de-pt');
    var tiles = buildTiles(rows, config);
    if (tiles) root.appendChild(tiles);

    var grid = el('div', 'de-pt__grid');
    var main = el('div', 'de-pt__main');
    var side = el('aside', 'de-pt__side');
    var card = el('div', 'de-pt__card');

    var title = el('h3', 'de-pt__card-title');
    title.innerHTML = icon('list');
    title.appendChild(document.createTextNode(heading ? clean(heading.textContent) : 'Specificaties'));

    Array.prototype.slice.call(content.childNodes).forEach(function (node) {
      if (node === table || node === heading) return;
      main.appendChild(node);
    });
    if (heading && heading.parentNode) heading.parentNode.removeChild(heading);

    card.appendChild(title);
    card.appendChild(table);

    var phone = config && clean(config.getAttribute('data-phone'));
    if (phone) {
      var contact = el('div', 'de-pt__contact');
      contact.innerHTML = icon('phone');
      var text = el('span');
      text.appendChild(document.createTextNode('Vraag over dit product? Bel '));
      var link = el('a');
      link.href = 'tel:' + phone.replace(/[^\d+]/g, '');
      link.textContent = phone;
      text.appendChild(link);
      contact.appendChild(text);
      card.appendChild(contact);
    }

    side.appendChild(card);
    grid.appendChild(main);
    grid.appendChild(side);
    root.appendChild(grid);
    content.appendChild(root);
  }

  function init(scope) {
    var sections = (scope || document).querySelectorAll('.section-tabs-content');
    for (var i = 0; i < sections.length; i++) {
      var section = sections[i];
      var config = section.querySelector('.de-pt-config');
      if (!config) continue; /* alleen secties die dit expliciet aanzetten */
      try {
        layoutFirstTab(section, config);
        addReviewCount(section, config);
      } catch (e) {
        if (window.console) console.warn('producttabs-layout:', e);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
